import { memo, useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useModal } from 'store/app/hooks'
import { resertConvertState } from 'store/convert/actions'
import { updateModal } from '../../store/app/actions/modalActions'
import ModalLink from 'components/ModalLink'
import { ExchangeContent, Space, ModalHeader } from './style'
import { TokenFrom } from './exchangeToken'
import { SwitchSymbol } from './switchSymbol'
import { ExchangeAmount } from './exchangeAmount'
import { ExchangeInfo } from './exchangeInfo'
import { ExchangeBtn } from './exchangeBtn'
import { ReactComponent as SvgClose } from './assets/close.svg'

export const ConvertModal = memo(() => {
  const dispatch = useDispatch()
  const openConvertModal = useModal('convert')

  useEffect(() => {
    if (!openConvertModal) {
      dispatch(resertConvertState())
    }
  }, [openConvertModal])

  const onClose = useCallback(() => {
    dispatch(
      updateModal({
        modal: 'convert',
        open: false,
      }),
    )
  }, [])

  return (
    <ModalLink
      isIn={openConvertModal}
      width="435px"
      onClose={onClose}
      maskClose={false}
      header={'Convert'}
    >
      <ExchangeContent>
        <TokenFrom typeName="From" />
        <SwitchSymbol />
        <TokenFrom typeName="To" />
        <Space />
        <ExchangeAmount />
        <ExchangeInfo />
        <ExchangeBtn />
      </ExchangeContent>
    </ModalLink>
  )
})
